import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import Select from '../../ui/Select/Select'
import { RadioGroup } from '../../ui'
import { CHANNELS, OUTPUT_FORMATS } from '../constants'

const CHANNEL_OPTIONS = [
  { label: 'Email', value: CHANNELS.EMAIL },
  { label: 'SFTP', value: CHANNELS.SFTP }
]

const OUTPUT_FORMAT_OPTIONS = [
  { id: 'format_xlsx', value: OUTPUT_FORMATS.XLSX, label: 'XLSX' },
  { id: 'format_csv', value: OUTPUT_FORMATS.CSV, label: 'CSV' },
  { id: 'format_pdf', value: OUTPUT_FORMATS.PDF, label: 'PDF' }
]

const ChannelFields = ({
  availableChannels, channel, credentialId, outputFormat, credentialOptions,
  credentialError, outputFormatError,
  showSftpOptions, onChannelChange, onFieldChange
}) => {
  const channelOptions = CHANNEL_OPTIONS.filter(
    option => availableChannels.includes(option.value)
  )
  const channelValue = channelOptions.find(
    option => option.value === channel
  )

  const selectedCredential = credentialOptions.find(
    option => option.value === credentialId
  ) || null

  const handleCredentialChange = useCallback(option => {
    onFieldChange('credentialId', option?.value)
  }, [onFieldChange])

  const handleFormatChange = useCallback(value => {
    onFieldChange('outputFormat', value)
  }, [onFieldChange])

  return (
    <>
      <div className="form-group">
        <label>Canal</label>
        <Select
          options={channelOptions}
          value={channelValue}
          onChange={onChannelChange}
        />
      </div>
      {showSftpOptions ? (
        <div className="form-group">
          <label>Identifiant SFTP</label>
          <Select
            options={credentialOptions}
            value={selectedCredential}
            error={Boolean(credentialError)}
            isClearable
            onChange={handleCredentialChange}
          />
          {credentialError ? (
            <small className="text-danger">
              {credentialError[0]}
            </small>
          ) : null}
        </div>
      ) : null}
      {showSftpOptions ? (
        <>
          <RadioGroup
            name="outputFormat"
            label="Format"
            options={OUTPUT_FORMAT_OPTIONS}
            value={outputFormat}
            inline
            onChange={handleFormatChange}
          />
          {outputFormatError ? (
            <small className="text-danger">
              {outputFormatError[0]}
            </small>
          ) : null}
        </>
      ) : null}
    </>
  )
}

ChannelFields.propTypes = {
  availableChannels: PropTypes.arrayOf(PropTypes.string).isRequired,
  channel: PropTypes.string.isRequired,
  credentialError: PropTypes.arrayOf(PropTypes.string),
  credentialId: PropTypes.number,
  credentialOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired
  })).isRequired,
  onChannelChange: PropTypes.func.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  outputFormat: PropTypes.string.isRequired,
  outputFormatError: PropTypes.arrayOf(PropTypes.string),
  showSftpOptions: PropTypes.bool.isRequired
}

ChannelFields.defaultProps = {
  credentialError: null,
  credentialId: null,
  outputFormatError: null
}

export default ChannelFields
